export default "__VITE_ASSET__BFx2dbJm__"